import * as React from 'react'
// libs
import styled from 'styled-components'
// icons
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

interface Props {
  riskId: string
  riskTemplateId: string
}

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  margin-right: -4px;
  cursor: pointer;

  && svg {
    display: block;
    width: 16px;
    height: 16px;
    fill: rgba(0, 0, 0, 0.51);
  }
`

export const getRiskUrl = (riskId: string, riskTemplateId: string) =>
  `/forms/edit/${riskId}/template/${riskTemplateId}`

export const openRisk = (riskId: string, riskTemplateId: string) =>
  window.open(getRiskUrl(riskId, riskTemplateId), '_blank')

// presentational icon — the click is handled by the element it is rendered in
export const RiskIcon: React.FC = () => (
  <Wrapper>
    <OpenInNewIcon />
  </Wrapper>
)

const OpenRiskLink: React.FC<Props> = ({ riskId, riskTemplateId }) => {
  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    openRisk(riskId, riskTemplateId)
  }

  return (
    <Wrapper onMouseDown={onMouseDown} onClick={onClick}>
      <OpenInNewIcon />
    </Wrapper>
  )
}

export default OpenRiskLink
